// extracted by mini-css-extract-plugin
module.exports = {"Collection":"Collection_Collection__VOnc0"};